<div class="prompt-wrapper">
  <div class="cards-row">
    <!-- Well Level Card -->
    <div class="prompt-card well-level-card">
      <!-- Header with toggle buttons -->
      <div class="card-header">
        <div class="header-text">
        <h3 class="card-title">Well Level</h3>
        <p class="card-subtitle">Suggested prompts for individual wells</p>
      </div>
        <div class="mode-toggle">
          <button
            type="button"
            (click)="setWellMode('single')"
            class="toggle-button"
            [ngClass]="{'active': wellMode === 'single'}">
            Single Well
          </button>
          <button
            type="button"
            (click)="setWellMode('multi')"
            class="toggle-button"
            [ngClass]="{'active': wellMode === 'multi'}">
            Multi Well
          </button>
        </div>
      </div>

      <!-- Single Well prompts -->
      <ng-container *ngIf="wellMode === 'single'">
        <div class="prompts-list">
          <button
            *ngFor="let prompt of wellLevelPrompts"
            type="button"
            (click)="handlePromptClick(prompt, 'well')"
            class="prompt-button"
            [ngClass]="{'active': (inputValue === prompt.label && selectedPromptType === 'well')}">
            <span class="prompt-text">{{ prompt.label }}</span>
            <span *ngIf="inputValue === prompt.label && selectedPromptType === 'well'" class="material-icon prompt-check">✓</span>
          </button>
        </div>
      </ng-container>

      <!-- Multi Well UI -->
      <ng-container *ngIf="wellMode === 'multi'">
        <!-- Backdrop to close dropdowns when clicking outside -->
        <div *ngIf="fieldDropdownOpen || multiDropdownOpen" 
          class="dropdown-backdrop" 
          (click)="fieldDropdownOpen = false; multiDropdownOpen = false">
        </div>

        <div class="multi-well-container">

          <!-- Field Dropdown -->
          <div class="dropdown-section field-dropdown-host">
            <div class="dropdown-label">Select Field(s)</div>
            <!-- Trigger button -->
            <div
              class="dropdown-trigger"
              (click)="openFieldDropdown()"
              [ngClass]="{'loading': loadingFields}">
              <span class="trigger-text" [ngClass]="{'placeholder': selectedFields.length === 0}">
                {{ loadingFields ? 'Loading fields...' : (selectedFields.length > 0 ? selectedFields.join(', ') : 'Select a field') }}
              </span>
              <img
                *ngIf="!loadingFields"
                [src]="fieldDropdownOpen ? 'assets/images/UpArrow.png' : 'assets/images/DownArrow.png'"
                alt="Dropdown"
                class="dropdown-chevron"
              />
              <img
                *ngIf="loadingFields"
                src="assets/images/spinner.png"
                alt="Loading"
                class="spinner-icon loading-spinner"
              />
            </div>

            <!-- Dropdown list -->
            <div *ngIf="fieldDropdownOpen"
              class="dropdown-menu small">
              <!-- Loading state -->
              <div *ngIf="loadingFields" class="dropdown-item loading-state">
                <img src="assets/images/spinner.png" alt="Loading" class="spinner-icon" />
                <span class="item-text">Loading fields...</span>
              </div>
              <!-- Fields list (scrollable) -->
              <div *ngIf="!loadingFields">
                <!-- Select All option -->
                <label *ngIf="fieldList.length > 0"
                  class="dropdown-item select-all"
                  style="cursor:pointer">
                  <input
                    type="checkbox"
                    [checked]="tempSelectedFields.length === fieldList.length && tempSelectedFields.length > 0"
                    (change)="toggleSelectAllFields()"
                  />
                  <span class="item-text"><strong>Select All</strong></span>
                </label>
                <!-- Individual fields -->
                <label
                  *ngFor="let field of fieldList"
                  class="dropdown-item"
                  style="cursor:pointer">
                  <input
                    type="checkbox"
                    [checked]="isFieldSelected(field)"
                    (change)="toggleFieldSelection(field)"
                  />
                  <span class="item-text">{{ field }}</span>
                </label>
                <div *ngIf="fieldList.length === 0" class="dropdown-item">No fields available</div>
              </div>
              <!-- OK and Cancel buttons -->
              <div class="dropdown-actions" *ngIf="!loadingFields">
                <button
                  type="button"
                  (click)="cancelFieldSelection()"
                  class="action-button cancel">
                  Cancel
                </button>
                <button
                  type="button"
                  (click)="confirmFieldSelection()"
                  [disabled]="tempSelectedFields.length === 0"
                  class="action-button confirm">
                  OK
                </button>
              </div>
            </div>
          </div>

          <!-- Multi Well Dropdown -->
          <div class="dropdown-section multi-well-dropdown-host">
            <!-- Trigger: shows chips of selected wells + search input -->
            <div
              class="multi-well-trigger"
              (click)="multiDropdownOpen = true; fieldDropdownOpen = false">
              <!-- Selected well chips inside the box -->
              <span *ngFor="let wellId of selectedWellIds"
                class="well-chip">
                {{ getWellNameById(wellId) }}
                <button
                  type="button"
                  (click)="$event.stopPropagation(); removeWell(wellId)"
                  class="chip-remove">
                  &times;
                </button>
              </span>
              <!-- Search input -->
              <input
                type="text"
                class="search-input"
                [placeholder]="selectedWellIds.length === 0 ? 'Search and select wells...' : ''"
                [(ngModel)]="multiWellSearch"
                name="multiWellSearch"
                (focus)="multiDropdownOpen = true; fieldDropdownOpen = false"
                (input)="multiDropdownOpen = true"
                (paste)="handlePasteWells($event)"
              />
              <!-- Dropdown chevron -->
              <img
                [src]="multiDropdownOpen ? 'assets/images/UpArrow.png' : 'assets/images/DownArrow.png'"
                alt="Dropdown"
                class="dropdown-chevron"
              />
            </div>

            <!-- Dropdown list -->
            <div *ngIf="multiDropdownOpen"
              class="dropdown-menu">
              <!-- Loading state -->
              <div *ngIf="loadingWells" class="dropdown-item">
                <img src="assets/images/spinner.png" alt="Loading" class="spinner-icon" />
                <span class="item-text">Loading wells...</span>
              </div>
              <!-- Select All option -->
              <label *ngIf="!loadingWells && filteredMultiWells.length > 0"
                class="dropdown-item select-all"
                [style.cursor]="selectedWellIds.length >= 30 ? 'not-allowed' : 'pointer'">
                <input
                  type="checkbox"
                  [checked]="selectedWellIds.length === filteredMultiWells.length && selectedWellIds.length > 0"
                  [disabled]="selectedWellIds.length >= 30"
                  (change)="toggleSelectAll()"
                />
                <span class="item-text"><strong>Select All</strong></span>
              </label>
              <!-- Wells list -->
              <label
                *ngFor="let w of filteredMultiWells"
                class="dropdown-item"
                [style.cursor]="(selectedWellIds.length >= 30 && !isWellSelected(w.id)) ? 'not-allowed' : 'pointer'">
                <input
                  type="checkbox"
                  [checked]="isWellSelected(w.id)"
                  [disabled]="selectedWellIds.length >= 30 && !isWellSelected(w.id)"
                  (change)="toggleWellSelection(w.id)"
                />
                <span class="item-text">
                  {{ w.name }}
                  <span *ngIf="w.field" class="well-field-name">({{ w.field }})</span>
                </span>
                <span *ngIf="isWellSelected(w.id)" class="material-icon checkmark">✓</span>
              </label>
              <div *ngIf="filteredMultiWells.length === 0 && !loadingWells" class="dropdown-item">No wells found</div>
            </div>
          </div>

          <!-- Selected count hint -->
          <p class="selection-hint">
            <span *ngIf="selectedWellIds.length === 0">No wells selected.</span>
            <span *ngIf="selectedWellIds.length > 0" class="count-text">{{ selectedWellIds.length }} well(s) selected</span>
          </p>

          <!-- Error message for selection limit -->
          <div *ngIf="wellSelectionError" class="error-message">
            <span class="error-icon">⚠️</span>
            <span class="error-text">{{ wellSelectionError }}</span>
          </div>

          <!-- Default information message -->
          <div *ngIf="!wellSelectionError" class="info-message">
            <span class="info-icon">ℹ️</span>
            <span class="info-text">You can select up to 30 wells. Paste multiple well names separated by comma, semicolon, or newline.</span>
          </div>

          <!-- Spacer to push buttons to bottom -->
          <div class="flex-spacer"></div>

          <!-- Cancel & Generate at the bottom -->
          <div class="button-group">
            <button
              type="button"
              (click)="clearAllSelections()"
              [disabled]="isLoading || (selectedWellIds.length === 0 && selectedFields.length === 0)"
              class="secondary-button">
              Clear
            </button>
            <!-- <button
              type="button"
              (click)="cancelMultiWell()"
              [disabled]="isLoading"
              class="secondary-button">
              Cancel
            </button> -->
            <button
              type="button"
              (click)="generateMultiWell()"
              [disabled]="selectedWellIds.length === 0 || isLoading"
              class="primary-button">
              <span>{{ isLoading ? 'Generating...' : 'Generate' }}</span>
              <img *ngIf="isLoading" src="assets/images/spinner.png" alt="Loading" class="spinner-icon" />

            </button>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- Field Level Card -->
    <div class="prompt-card field-level-card">
      <div class="card-header">
      <div class="header-text">
      <h3 class="card-title">Field Level</h3>
        <p class="card-subtitle">Suggested prompts for field-level analysis</p>
    </div>
      </div>
      <div class="prompts-list">
        <button
          *ngFor="let prompt of fieldLevelPrompts"
          type="button"
          (click)="handlePromptClick(prompt, 'field')"
          class="prompt-button"
          [ngClass]="{'active': (inputValue === prompt.label && selectedPromptType === 'field')}">
          <span class="prompt-text">{{ prompt.label }}</span>
          <span *ngIf="inputValue === prompt.label && selectedPromptType === 'field'" class="material-icon checkmark">✓</span>
        </button>
      </div>
    </div>
  </div>
  <!-- Input bar at the bottom -->
  <form class="input-form"
    (submit)="$event.preventDefault(); handleSubmit()"
    [ngClass]="{'loading': isLoading}">
    <img src="assets/images/star.png" alt="Star" class="input-icon" />
    <input
      type="text"
      class="input-field"
      placeholder="Select a question above or type your own..."
      [(ngModel)]="inputValue"
      (input)="onInputChange()"
      name="promptInput"
      [disabled]="isLoading"
    />
    <!-- Show loader when loading -->
    <div *ngIf="isLoading" class="input-loader">
      <img src="assets/images/spinner.png" alt="Loading" class="spinner-icon" />
    </div>
    <!-- Show submit button when not loading -->
    <button
      *ngIf="!isLoading"
      type="submit"
      [disabled]="!inputValue.trim()"
      class="send-button send-btn">
      <span class="material-icon">➤</span>
    </button>
  </form>
</div>
